<template>
  <div class="scmcc-layout-blank">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'layoutBlank',
  created() {
    // 清空eventbus
    this.$eventBus.clean()
    // 退出业务
    this.$eventBus.on('scmcc/logout', () => {
      let logout = () => {
        this.$http.get('/sctm/auth/logOut').then(() => {
          // 电话条签出
          window.softPhoneApi && window.softPhoneApi.softPhoneOut()
          // 关闭WS
          if (this.$store.state.main.WS) this.$store.state.main.WS.close()
          // 清除用户信息
          this.$store.commit('main/user/clear')
          // 清除cookies
          Cookies.remove('needCheckCode')
          Cookies.remove('JSESSIONID')
          this.$router.push({ query: { logout: true } })
          location.reload()
        })
      }
      if (this.$store.state.scim_ui) {
        this.$store
          .dispatch('scim_ui/endAllSession') // 退出前先迁出坐席
          .then(() => {
            logout()
          })
          .catch(() => {
            logout()
          })
      } else {
        logout()
      }
    })
  }
}
</script>

<style lang="stylus">
.scmcc-layout-blank
  height 100vh
  width 100vw
</style>
